import React, { useEffect, lazy, Suspense } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ImageHoverPreview from "./component/ImageHoverPreview";
import Login from "./Pages/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Route-level code splitting: every page loads on demand instead of shipping
// in the main bundle. Login stays eager so first paint is instant.
const Registration = lazy(() => import("./Pages/Registration"));
const DashboardAdmin = lazy(() => import("./Pages/DashboardAdmin"));
const ExpenseForm = lazy(() => import("./Pages/ExpenseForm"));
const AdminUpdateMultiVoucher = lazy(() => import("./Pages/AdminUpdateMultiVoucher"));
const ExpenseRequestHR = lazy(() => import("./Pages/ExpenseRequestHR"));
const DashboardAccount = lazy(() => import("./Pages/DashboardAccount"));
const ExpenseRequestAdmin = lazy(() => import("./Pages/ExpenseRequestAdmin"));
const AdminUpdateTrevelVoucherDetails = lazy(() => import("./Pages/AdminUpdateTrevelVoucherDetails"));
const EditTravelVoucher = lazy(() => import("./Pages/EditTravelVoucher"));
const UserVoucherFill = lazy(() => import("./Pages/UserVoucherFill"));
const AdminDraftVoucherfinal = lazy(() => import("./Pages/AdminDraftVoucherfinal"));
const AdminVoucerDetailsFill = lazy(() => import("./Pages/AdminVoucerDetailsFill"));
const TravelExpenseRequestAccountant = lazy(() => import("./Pages/TravelExpenseRequestAccountant"));
const EditEvent = lazy(() => import("./Pages/EditEvent"));
const ExpenseRequestAccountantnew = lazy(() => import("./Pages/ExpenseRequestAccountantnew"));
const AccountantEditMultiVoucherFill = lazy(() => import("./Pages/AccountantEditMultiVoucherFill"));
const AccountantEditLocalConveyanceVoucherFill = lazy(() => import("./Pages/AccountantEditLocalConveyanceVoucherFill"));
const Test = lazy(() => import("./Pages/Test"));
const ExpenseRequestAccountant = lazy(() => import("./Pages/ExpenseRequestAccountant"));
const TravelVoucherFill = lazy(() => import("./Pages/TravelVoucherFill"));
const TravelUserVoucherDetails = lazy(() => import("./Pages/TravelUserVoucherDetails"));
const AdminEditVoucher = lazy(() => import("./Pages/AdminEditVoucher"));
const AdminVoucherEditByUser = lazy(() => import("./Pages/AdminVoucherEditByUser"));
const AcceptedVoucher = lazy(() => import("./Pages/AcceptedVoucher"));
const PendingVoucher = lazy(() => import("./Pages/PendingVoucher"));
const RejectedVoucher = lazy(() => import("./Pages/RejectedVoucher"));
const AdminTravelVoucherFill = lazy(() => import("./Pages/AdminTravelVoucherFill"));
const TravelExpenseRequest = lazy(() => import("./Pages/TravelExpenseRequest"));
const AnalyticsVoucher = lazy(() => import("./Pages/AnalyticsVoucher"));
const TravelExpUserPage = lazy(() => import("./Pages/TravelExpUserPage"));
const TravelExpUserPageaccountant = lazy(() => import("./Pages/TravelExpUserPageaccountant"));
const DraftVoucerDetailsFill = lazy(() => import("./Pages/DraftVoucerDetailsFill"));
const AccVoucherFill = lazy(() => import("./Pages/AccVoucherFill"));
const AdminUpdateVoucherDetails = lazy(() => import("./Pages/AdminUpdateVoucherDetails"));
const ApprovedAdminVoucherdetails = lazy(() => import("./Pages/ApprovedAdminVoucherdetails"));
const AccMultiVoucherFill = lazy(() => import("./Pages/AccMultiVoucherFill"));
const EditVoucher = lazy(() => import("./Pages/EditVoucher"));
const AdminLocalConveyanceVoucherFill = lazy(() => import("./Pages/AdminLocalConveyanceVoucherFill "));
const UserLocalConveyanceVoucher = lazy(() => import("./Pages/UserLocalConveyanceVoucher"));
const UserVoucherMulti = lazy(() => import("./Pages/UserVoucherMulti"));
const AdminMultiVoucherFill = lazy(() => import("./Pages/AdminMultiVoucherFill"));
const EditMultiVoucher = lazy(() => import("./Pages/EditMultiVoucher"));
const EditLocalConveyanceVoucher = lazy(() => import("./Pages/EditLocalConveyanceVoucher"));
const AdminUpdateLocalConveyanceVoucher = lazy(() => import("./Pages/AdminUpdateLocalConveyanceVoucher"));
const AllAnalytics = lazy(() => import("./Pages/AllAnalytics"));
const ProfilePage = lazy(() => import("./Pages/ProfilePage"));
const VoucherDetails = lazy(() => import("./Pages/VoucherDetails"));
const AdminExpenseFillByAcc = lazy(() => import("./Pages/AdminExpenseFillByAcc"));
const UpdateProfileUser = lazy(() => import("./Pages/UpdateProfileUser"));
const AdminVoucherDetailsAll = lazy(() => import("./Pages/AdminVoucherDetailsAll"));
const UserDetails = lazy(() => import("./Pages/UserDetails"));
const AdminMultiVoucherByAcc = lazy(() => import("./Pages/AdminMultiVoucherByAcc"));
const EditUserProfile = lazy(() => import("./Pages/EditUserProfile"));
const AllAppliedAnalytics = lazy(() => import("./Pages/AllAppliedAnalytics"));
const OfficialFillbyAccountant = lazy(() => import("./Pages/OfficialFillByAccountant"));
const AllAppliedAnalyticsyqm = lazy(() => import("./Pages/AllAppliedAnalyticsyqm"));
const EditVoucherAccountant = lazy(() => import("./Pages/EditVoucherAccountant"));
const Updateaccforadmin = lazy(() => import("./Pages/Updateaccforadmin"));
const Salary = lazy(() => import("./Pages/Salary"));
const OfficialHistory = lazy(() => import("./Pages/OfficialHistory"));
const AdminHistoryOff = lazy(() => import("./Pages/AdminHistoryOff"));
const ExpenseRequestAccountantbatch = lazy(() => import("./Pages/ExpenseRequestAccountantbatch"));
const TravelEventEdit = lazy(() => import("./Pages/TravelEventEdit"));
const SalaryDetails = lazy(() => import("./Pages/SalaryDetails"));
const AdminVoucherHistoryDetails = lazy(() => import("./Pages/AdminVoucherHistoryDetails"));
const DeductionDetails = lazy(() => import("./Pages/DeductionDetails"));
const UserEvent = lazy(() => import("./Pages/UserEvent"));
const AdminEventList = lazy(() => import("./Pages/AdminEventList"));
const AccEventList = lazy(() => import("./Pages/AccEventList"));
const UserLists = lazy(() => import("./Pages/UserLists"));
const Purchase = lazy(() => import("./Pages/Purchase"));
const Sales = lazy(() => import("./Pages/Sales"));
const Master = lazy(() => import("./Pages/Master"));
const CompanyMaster = lazy(() => import("./Pages/CompanyMaster"));
const BankMaster = lazy(() => import("./Pages/BankMaster"));
const TravelEvents = lazy(() => import("./Pages/TravelEvents"));
const PaymentMaster = lazy(() => import("./Pages/PaymentMaster"));
const ExpenseMaster = lazy(() => import("./Pages/ExpenseMaster"));
const ExpenseSubMaster = lazy(() => import("./Pages/ExpenseSubMaster"));
const LocationMaster = lazy(() => import("./Pages/LocationMaster"));
const CreateDraft = lazy(() => import("./Pages/CreateDraft"));
const DraftList = lazy(() => import("./Pages/DraftList"));
const Dashboard = lazy(() => import("./Pages/Dashboard"));
const CompletedExpense = lazy(() => import("./Pages/CompletedExpense"));
const Reconsilation = lazy(() => import("./Pages/Reconsilation"));
const ProjectMaster = lazy(() => import("./Pages/ProjectMaster"));
const Inventory = lazy(() => import("./Pages/Inventory"));
const InventoryMaster = lazy(() => import("./Pages/InventoryMaster"));
const ProjectList = lazy(() => import("./Pages/ProjectList"));
const ProjectVoucherList = lazy(() => import("./Pages/ProjectVoucherList"));
const VoucherFullDetail = lazy(() => import("./Pages/VoucherFullDetail"));
const ExpenseRequestAccountantbatchlist = lazy(() => import("./Pages/ExpenseRequestAccountantbatchlist"));
const AccountantVoucherFullDetail = lazy(() => import("./Pages/AccountantVoucherFullDetail"));
const AdminVoucherFullDetail = lazy(() => import("./Pages/AdminVoucherFullDetail"));
const ExpenseDeclaration = lazy(() => import("./Pages/ExpenseDeclaration"));
const ExpenseRequestAdminList = lazy(() => import("./Pages/ExpenseRequestAdminList"));
const PaidExpensesAccountant = lazy(() => import("./Pages/PaidExpensesAccountant"));
const BatchVoucherListAccountant = lazy(() => import("./Pages/BatchVoucherListAccountant"));
const BatchPaymentAccountant = lazy(() => import("./Pages/BatchPaymentAccountant"));
const BankStatement = lazy(() => import("./Pages/BankStatement"));
const RevokeEditVoucher = lazy(() => import("./Pages/RevokeEditVoucher"));
const AccountantTravelVoucherList = lazy(() => import("./Pages/AccountantTravelVoucherList"));
const Payroll = lazy(() => import("./Pages/Payroll"));
const AdminTransactions = lazy(() => import("./Pages/AdminTransactions"));

const EventCreate = lazy(() => import("./component/EventCreate"));
const AdminEvent = lazy(() => import("./component/AdminEvent"));
const TravelEventCreate = lazy(() => import("./component/TravelEventCreate"));
const ApprovedList = lazy(() => import("./component/ApprovedList"));
const PendingExpense = lazy(() => import("./component/PendingExpense"));
const AllAnalyticsAfterFilter = lazy(() => import("./component/AllAnalyticsAfterFilter"));
const NewPurchaseEntry = lazy(() => import("./component/NewPurchaseEntry"));
const NewSalesEntry = lazy(() => import("./component/NewSalesEntry"));
const EventCreatedTable = lazy(() => import("./component/EventCreatedTable"));
const TravelEventVoucher = lazy(() => import("./component/TravelEventVoucher"));
const PurchaseApply = lazy(() => import("./component/PurchaseApply"));
const PurchaseList = lazy(() => import("./component/PurchaseList"));

const PageLoader = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-[#F8FAFC]">
    <div className="flex flex-col items-center gap-3">
      <div className="w-10 h-10 border-4 border-slate-200 border-t-blue-600 rounded-full animate-spin"></div>
      <p className="text-[10px] text-slate-500 font-bold uppercase tracking-widest">Loading…</p>
    </div>
  </div>
);

const App = () => {
  const user = useSelector((state) => state.auth.user);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        // Check if any modal/popup is visibly open
        const modals = document.querySelectorAll(
          '[role="dialog"], [aria-modal="true"], .z-\\[1000\\], .z-\\[9999\\]'
        );
        let isModalVisible = false;
        for (let i = 0; i < modals.length; i++) {
          const style = window.getComputedStyle(modals[i]);
          if (style.display !== "none" && style.visibility !== "hidden") {
            isModalVisible = true;
            break;
          }
        }

        // If a modal is open, let the modal handle the Escape key. Do not navigate back.
        if (isModalVisible) {
          return;
        }

        const activeEl = document.activeElement;
        const isInputActive = activeEl && (
          activeEl.tagName === "INPUT" ||
          activeEl.tagName === "TEXTAREA" ||
          activeEl.tagName === "SELECT" ||
          activeEl.isContentEditable
        );
        if (!isInputActive) {
          event.preventDefault();
          navigate(-1);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  return (
    <>
      <ToastContainer position="top-center" reverseOrder={true} />
      <ImageHoverPreview />

      <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Test" element={<Test />} />
        <Route path="/EventCreate" element={<EventCreate />} />
        <Route path="/EditVoucher" element={<EditVoucher />} />
        <Route path="/EditEvent" element={<EditEvent />} />
        <Route path="/ExpenseRequestAccountantbatch" element={<ExpenseRequestAccountantbatch />} />
        <Route path="/ExpenseRequestAccountantbatchlist" element={<ExpenseRequestAccountantbatchlist />} />
        <Route path="/AccountantVoucherFullDetail" element={<AccountantVoucherFullDetail />} />
        <Route path="/AdminVoucherFullDetail" element={<AdminVoucherFullDetail />} />
        <Route path="/UserVoucherMulti" element={<UserVoucherMulti />} />
        <Route path="/VoucherDetails" element={<VoucherDetails />} />
        <Route path="/UpdateProfileUser" element={<UpdateProfileUser />} />
        <Route path="/EditTravelVoucher" element={<EditTravelVoucher />} />
        <Route path="/ProfilePage" element={<ProfilePage />} />
        <Route path="/EditMultiVoucher" element={<EditMultiVoucher />} />
        <Route path="/EditLocalConveyanceVoucher" element={<EditLocalConveyanceVoucher />} />
        <Route
          path="/UserLocalConveyanceVoucher"
          element={<UserLocalConveyanceVoucher />}
        />

        {isLoggedIn ? (
          <>
            {/* Custom Project Routes */}
            <Route path="/Inventory" element={<InventoryMaster />} />
            <Route path="/ExpenseDeclaration" element={<ExpenseDeclaration />} />
            <Route path="/RevokeEditVoucher" element={<RevokeEditVoucher />} />
            <Route path="/AdminVoucherHistoryDetails" element={<AdminVoucherHistoryDetails />} />
            <Route path="/VoucherFullDetail/:voucherId" element={<VoucherFullDetail />} />

            {(user?.role === "User" || user?.role === "HR") && (
              <>
                <Route path="/Dashboard" element={<Dashboard />} />
                <Route path="/UserVoucherFill" element={<UserVoucherFill />} />
                {/* User 43 Admin Fill Access */}
                {user?.userId === 43 && (
                  <Route
                    path="/AdminExpenseFillByAcc"
                    element={<AdminExpenseFillByAcc />}
                  />
                )}
                <Route
                  path="/TravelVoucherFill"
                  element={<TravelVoucherFill />}
                />
                <Route
                  path="/AnalyticsVoucher"
                  element={<AnalyticsVoucher />}
                />
                <Route path="/AcceptedVoucher" element={<AcceptedVoucher />} />
                <Route path="/PendingVoucher" element={<PendingVoucher />} />
                <Route path="/RejectedVoucher" element={<RejectedVoucher />} />
                <Route path="/UserEvent" element={<UserEvent />} />

                {user?.userId === 28 && (
                  <Route path="/UserLists" element={<UserLists />} />
                )}

                {/* --- ALL USER 41 CONSOLIDATED PAGES --- */}
                {user?.userId === 41 && (
                  <>
                    <Route path="/Purchase" element={<Purchase />} />
                    <Route path="/Sales" element={<Sales />} />
                    <Route
                      path="/NewSalesEntry"
                      element={<NewSalesEntry />}
                    />
                    <Route
                      path="/NewPurchaseEntry"
                      element={<NewPurchaseEntry />}
                    />
                    <Route
                      path="/OfficialFillbyAccountant"
                      element={<OfficialFillbyAccountant />}
                    />
                    <Route path="/AdminEvent" element={<AdminEvent />} />
                    <Route
                      path="/AdminMultiVoucherByAcc"
                      element={<AdminMultiVoucherByAcc />}
                    />
                    <Route
                      path="/AdminExpenseFillByAcc"
                      element={<AdminExpenseFillByAcc />}
                    />
                    <Route
                      path="/AdminHistoryOff"
                      element={<AdminHistoryOff />}
                    />
                    <Route
                      path="/AdminUpdateMultiVoucher"
                      element={<AdminUpdateMultiVoucher />}
                    />
                    <Route
                      path="/AdminUpdateLocalConveyanceVoucher"
                      element={<AdminUpdateLocalConveyanceVoucher />}
                    />
                  </>
                )}
              </>
            )}

            {user?.role === "Admin" && (
              <>
                <Route path="/DashboardAdmin" element={<DashboardAdmin />} />
                <Route
                  path="/CompletedExpense"
                  element={<CompletedExpense />}
                />
                <Route
                  path="/EventCreatedTable"
                  element={<EventCreatedTable />}
                />
                <Route
                  path="/AdminEventList"
                  element={<AdminEventList />}
                />
                <Route
                  path="/TravelEventVoucher"
                  element={<TravelEventVoucher />}
                />
                <Route
                  path="/ExpenseRequestAdmin"
                  element={<ExpenseRequestAdmin />}
                />
                <Route
                  path="/ExpenseRequestAdminList"
                  element={<ExpenseRequestAdminList />}
                />
                <Route
                  path="/AdminVoucherFullDetail"
                  element={<AdminVoucherFullDetail />}
                />
                <Route
                  path="/AdminVoucerDetailsFill"
                  element={<AdminVoucerDetailsFill />}
                />
                {user?.userId === 43 && (
                  <Route
                    path="/AdminExpenseFillByAcc"
                    element={<AdminExpenseFillByAcc />}
                  />
                )}
                <Route
                  path="/AdminTravelVoucherFill"
                  element={<AdminTravelVoucherFill />}
                />
                <Route
                  path="/TravelEventCreate"
                  element={<TravelEventCreate />}
                />
                <Route
                  path="/TravelEventEdit"
                  element={<TravelEventEdit />}
                />
                <Route
                  path="/TravelExpenseRequest"


                  element={<TravelExpenseRequest />}
                />
                <Route
                  path="/TravelUserVoucherDetails"
                  element={<TravelUserVoucherDetails />}
                />
                <Route path="/Registration" element={<Registration />} />
                <Route
                  path="/TravelExpUserPage"
                  element={<TravelExpUserPage />}
                />
                <Route
                  path="/AllAppliedAnalytics"
                  element={<AllAppliedAnalytics />}
                />
                <Route path="/EditUserProfile" element={<EditUserProfile />} />
                <Route
                  path="/AdminEditVoucher"
                  element={<AdminEditVoucher />}
                />
                <Route
                  path="/AdminVoucherEditByUser"
                  element={<AdminVoucherEditByUser />}
                />
                <Route
                  path="/AdminLocalConveyanceVoucherFill"
                  element={<AdminLocalConveyanceVoucherFill />}
                />
                <Route
                  path="/AllAppliedAnalyticsyqm"
                  element={<AllAppliedAnalyticsyqm />}
                />
                <Route
                  path="/ApprovedAdminVoucherdetails"
                  element={<ApprovedAdminVoucherdetails />}
                />
                <Route
                  path="/AdminMultiVoucherFill"
                  element={<AdminMultiVoucherFill />}
                />
                <Route
                  path="/AdminVoucherDetailsAll"
                  element={<AdminVoucherDetailsAll />}
                />
                <Route
                  path="/AdminUpdateVoucherDetails"
                  element={<AdminUpdateVoucherDetails />}
                />
                <Route
                  path="/AdminUpdateTrevelVoucherDetails"
                  element={<AdminUpdateTrevelVoucherDetails />}
                />

                <Route path="/AllAnalytics" element={<AllAnalytics />} />
                <Route path="/BankStatement" element={<BankStatement />} />
                {/* Same cash book the accountant sees at /Payroll. Kept as its own
                    path so the admin menu and the dashboard drill-through have a
                    stable destination. */}
                <Route path="/AdminTransactions" element={<AdminTransactions />} />
                <Route path="/Payroll" element={<Payroll />} />

                <Route path="/Salary" element={<Salary />} />
                <Route
                  path="/DraftVoucerDetailsFill"
                  element={<DraftVoucerDetailsFill />}
                />

                <Route path="/ExpenseForm" element={<ExpenseForm />} />
                <Route
                  path="/AdminUpdateMultiVoucher"
                  element={<AdminUpdateMultiVoucher />}
                />
                <Route
                  path="/AdminUpdateLocalConveyanceVoucher"
                  element={<AdminUpdateLocalConveyanceVoucher />}
                />
                <Route
                  path="/AdminDraftVoucherfinal"
                  element={<AdminDraftVoucherfinal />}
                />
                <Route path="/UserDetails" element={<UserDetails />} />
                <Route path="/ApprovedList" element={<ApprovedList />} />
                <Route
                  path="/AllAnalytics-PendingExpense"
                  element={<PendingExpense />}
                />

                <Route path="/UserLists" element={<UserLists />} />
                <Route
                  path="/AllAnalytics-FilterExpense"
                  element={<AllAnalyticsAfterFilter />}
                />
                <Route path="/Master" element={<Master />} />
                <Route path="/CompanyMaster" element={<CompanyMaster />} />
                <Route path="/BankMaster" element={<BankMaster />} />
                <Route path="/TravelEvents" element={<TravelEvents />} />
                <Route path="/PaymentMaster" element={<PaymentMaster />} />
                <Route path="/ExpenseMaster" element={<ExpenseMaster />} />
                <Route
                  path="/ExpenseSubMaster"
                  element={<ExpenseSubMaster />}
                />
                <Route path="/LocationMaster" element={<LocationMaster />} />
                <Route path="/CreateDraft" element={<CreateDraft />} />
                <Route path="/DraftList" element={<DraftList />} />
                <Route path="/PurchaseList" element={<PurchaseList />} />
                <Route path="/Sales" element={<Sales />} />
                <Route
                  path="/NewSalesEntry"
                  element={<NewSalesEntry />}
                />
                <Route path="/ProjectMaster" element={<ProjectMaster />} />
                <Route path="/ProjectList" element={<ProjectList />} />
                <Route path="/ProjectVoucherList/:projectId" element={<ProjectVoucherList />} />
              </>
            )}
            {user?.role === "Accountant" && (
              <>
                <Route
                  path="/DashboardAccount"
                  element={<DashboardAccount />}
                />
                <Route
                  path="/OfficialHistory"
                  element={<OfficialHistory />}
                />
                <Route
                  path="/AccEventList"
                  element={<AccEventList />}
                />

                <Route
                  path="/AllAnalytics-PendingExpense"
                  element={<PendingExpense />}
                />
                <Route path="/UserLists" element={<UserLists />} />

                <Route
                  path="/ExpenseRequestAccountant"
                  element={<ExpenseRequestAccountant />}
                />
                <Route path="/UserVoucherFill" element={<UserVoucherFill />} />
                <Route
                  path="/OfficialFillbyAccountant"
                  element={<OfficialFillbyAccountant />}
                />
                <Route
                  path="/TravelVoucherFill"
                  element={<TravelVoucherFill />}
                />
                <Route
                  path="/AllAppliedAnalytics"
                  element={<AllAppliedAnalytics />}
                />
                <Route
                  path="/AllAppliedAnalyticsyqm"
                  element={<AllAppliedAnalyticsyqm />}
                />
                <Route
                  path="/TravelExpenseRequestAccountant"
                  element={<TravelExpenseRequestAccountant />}
                />
                <Route path="/Registration" element={<Registration />} />
                <Route
                  path="/TravelExpUserPageaccountant"
                  element={<TravelExpUserPageaccountant />}
                />
                <Route
                  path="/AdminVoucherDetailsAll"
                  element={<AdminVoucherDetailsAll />}
                />
                <Route path="/AccVoucherFill" element={<AccVoucherFill />} />
                <Route
                  path="/AccMultiVoucherFill"
                  element={<AccMultiVoucherFill />}
                />
                <Route path="/UserDetails" element={<UserDetails />} />
                <Route
                  path="/ExpenseRequestAccountantnew"
                  element={<ExpenseRequestAccountantnew />}
                />
                <Route
                  path="/ApprovedAdminVoucherdetails"
                  element={<ApprovedAdminVoucherdetails />}
                />
                <Route
                  path="/EditVoucherAccountant"
                  element={<EditVoucherAccountant />}
                />
                <Route
                  path="/AdminMultiVoucherByAcc"
                  element={<AdminMultiVoucherByAcc />}
                />
                <Route path="/AdminEvent" element={<AdminEvent />} />
                <Route
                  path="/AdminExpenseFillByAcc"
                  element={<AdminExpenseFillByAcc />}
                />
                <Route
                  path="/ExpenseRequestAdmin"
                  element={<ExpenseRequestAdmin />}
                />
                <Route
                  path="/ExpenseRequestAdminList"
                  element={<ExpenseRequestAdminList />}
                />
                <Route
                  path="/AccountantEditMultiVoucherFill"
                  element={<AccountantEditMultiVoucherFill />}
                />
                <Route
                  path="/AccountantEditLocalConveyanceVoucherFill"
                  element={<AccountantEditLocalConveyanceVoucherFill />}
                />

                <Route path="/AllAnalytics" element={<AllAnalytics />} />
                <Route path="/BankStatement" element={<BankStatement />} />
                <Route
                  path="/ExpenseRequestAccountantbatch"
                  element={<ExpenseRequestAccountantbatch />}
                />
                <Route
                  path="/ExpenseRequestHR"
                  element={<ExpenseRequestHR />}
                />
                <Route
                  path="/Updateaccforadmin"
                  element={<Updateaccforadmin />}
                />
                <Route path="/Payroll" element={<Payroll />} />
                <Route path="/Salary" element={<Salary />} />
                <Route path="/SalaryDetails" element={<SalaryDetails />} />
                <Route
                  path="/DeductionDetails"
                  element={<DeductionDetails />}
                />
                <Route path="/ApprovedList" element={<ApprovedList />} />

                <Route path="/Purchase" element={<Purchase />} />
                <Route path="/purchaseApply" element={<PurchaseApply />} />
                <Route
                  path="/NewPurchaseEntry"
                  element={<NewPurchaseEntry />}
                />
                <Route path="/Inventory" element={<Inventory />} />

                <Route path="/Reconsilation" element={<Reconsilation />} />
                <Route path="/Sales" element={<Sales />} />
                <Route
                  path="/NewSalesEntry"
                  element={<NewSalesEntry />}
                />
                <Route path="/PaidExpensesAccountant" element={<PaidExpensesAccountant />} />
                <Route path="/BatchVoucherListAccountant" element={<BatchVoucherListAccountant />} />
                <Route path="/BatchPaymentAccountant" element={<BatchPaymentAccountant />} />
                <Route path="/AccountantTravelVoucherList" element={<AccountantTravelVoucherList />} />
                <Route path="/Master" element={<Master />} />
                <Route path="/CompanyMaster" element={<CompanyMaster />} />
                <Route path="/BankMaster" element={<BankMaster />} />
                <Route path="/TravelEvents" element={<TravelEvents />} />
                <Route path="/PaymentMaster" element={<PaymentMaster />} />
                <Route path="/ExpenseMaster" element={<ExpenseMaster />} />
                <Route
                  path="/ExpenseSubMaster"
                  element={<ExpenseSubMaster />}
                />
                <Route path="/LocationMaster" element={<LocationMaster />} />
                <Route path="/ProjectMaster" element={<ProjectMaster />} />
                <Route path="/ProjectList" element={<ProjectList />} />
                <Route path="/ProjectVoucherList/:projectId" element={<ProjectVoucherList />} />
              </>

            )}
          </>
        ) : (
          <Route path="*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
      </Suspense>
    </>
  );
};

export default App;
